import { TabletOpenPortraitParams } from "../types/index-type";
import { initQueryselectorTablet } from "./init-queryselector-tablet";


const isHTMLElement = (element: Element | null): element is HTMLElement =>
  element instanceof HTMLElement;

export const initTabletOpenPortrait = ({
  wholeLeftPositionOpen,
  sidebarColumnsPortrait,
  mainColumnsPortrait,
}: TabletOpenPortraitParams) => {
  const selectors = initQueryselectorTablet();
  const { grid, sideBarButton, codeArticle } = selectors;

  if (isHTMLElement(grid)) {
    grid.style.left = `${wholeLeftPositionOpen}vw`;
    grid.style.gridTemplateColumns = `${sidebarColumnsPortrait}vw ${mainColumnsPortrait}vw`;
  }

  codeArticle.forEach((article) => {
    article.style.width = "100%";
  });

  if (isHTMLElement(sideBarButton)) {
    sideBarButton.textContent = "CLOSE";
  }

  return selectors;
};
